import { Box, Card, CardContent, Typography } from '@mui/material';

const LeaveMetricCard = ({ title, value, subtitle, icon, bgColor }) => {
  return (
    <Card
      elevation={0}
      sx={{
        borderRadius: '20px',
        backgroundColor: bgColor,
        position: 'relative',
        minHeight: 140,
      }}
    >
      <CardContent>
        {/* Icon Circle */}
        <Box
          sx={{
            position: 'absolute',
            top: 20,
            right: 20,
            backgroundColor: 'rgba(255,255,255,0.4)',
            borderRadius: '50%',
            p: 1.5,
            display: 'flex',
            alignItems: 'center',
          }}
        >
          {icon}
        </Box>

        <Typography variant="subtitle1" color="text.secondary">
          {title}
        </Typography>

        <Typography variant="h4" fontWeight={600} mt={2}>
          {value}
        </Typography>

        {subtitle && (
          <Typography variant="body2" color="text.secondary" mt={1}>
            {subtitle}
          </Typography>
        )}
      </CardContent>
    </Card>
  );
};

export default LeaveMetricCard;
